import e from "./extends3.mjs";
const r = (o) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: e({}, o)
      }
    }
  }
});
export {
  r as getPickersLocalization
};
//# sourceMappingURL=getPickersLocalization.mjs.map
